import { jsx as _jsx } from "react/jsx-runtime";
import EnumMultiSelect from '../multiselect/EnumMultiSelect';
export var FilterEnumMultiSelect = function (_a) {
    var item = _a.item, type = _a.type, _b = _a.customItems, customItems = _b === void 0 ? [] : _b, setFilter = _a.setFilter, activeFilters = _a.activeFilters, label = _a.label, isAlwaysVisible = _a.isAlwaysVisible, enabled = _a.enabled;
    return ({
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(EnumMultiSelect, { type: type, selection: activeFilters[item], onChange: function (value) {
                var _a;
                return setFilter((_a = {}, _a[item] = value !== null && value !== void 0 ? value : undefined, _a));
            }, placeholder: label, sortById: false, customItems: customItems })),
    });
};
